import { useEffect, useState } from 'react';
import api from '../utils/api';

const FALLBACK_NUMBER = '917200252350';

// Shared source for the store WhatsApp number — reads admin Settings (whatsapp_number).
// Returns the digits-only number so it can be used directly in wa.me links.
export default function useWhatsAppNumber() {
  const [number, setNumber] = useState(FALLBACK_NUMBER);

  useEffect(() => {
    api.get('/settings/public')
      .then(({ data }) => {
        const num = data.settings?.whatsapp_number;
        if (num) setNumber(String(num).replace(/\D/g, ''));
      })
      .catch(() => {});
  }, []);

  return number;
}
